import { Capacitor } from "@capacitor/core";

const RINGTONE_SRC = "/call_incoming.ogg";
const VIBRATION_PATTERN = [0, 600, 200, 600];

let audio;
let vibrationTimer = null;
let isActive = false;

const canUseAudio = typeof Audio !== "undefined";
const canVibrate =
  typeof navigator !== "undefined" && typeof navigator.vibrate === "function";

export function startIncomingCallAlert(options = {}) {
  if (isActive) return;
  if (!Capacitor?.getPlatform) return;
  if (typeof document !== "undefined" && document.visibilityState === "hidden") {
    return;
  }

  isActive = true;
  const playSound = options.playSound !== false;
  const vibrate = options.vibrate !== false;

  if (canUseAudio && playSound) {
    if (!audio) {
      audio = new Audio(RINGTONE_SRC);
      audio.loop = true;
      audio.preload = "auto";
    }

    audio.currentTime = 0;
    audio.play().catch((err) => {
      console.warn("[BlueWire] Ringtone playback blocked:", err);
    });
  }

  if (canVibrate && vibrate) {
    navigator.vibrate(VIBRATION_PATTERN);
    vibrationTimer = window.setInterval(
      () => navigator.vibrate(VIBRATION_PATTERN),
      2200
    );
  }
}

export function stopIncomingCallAlert() {
  if (!isActive) return;

  isActive = false;

  if (audio) {
    audio.pause();
    audio.currentTime = 0;
  }

  if (vibrationTimer) {
    clearInterval(vibrationTimer);
    vibrationTimer = null;
  }

  if (canVibrate) {
    navigator.vibrate(0);
  }
}
